import { render, staticRenderFns } from "./editNotepad.vue?vue&type=template&id=7c7b28a6"
import script from "./editNotepad.vue?vue&type=script&lang=js"
export * from "./editNotepad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports